import { Tooltip } from 'antd'
import { IProfile } from 'interfaces/profiles'
import {
  ProfileBadge,
  ProfileOverflowBadge,
} from 'components/reusables/profileBadge'
import { Wrapper } from './styled'

interface IProps {
  items: IProfile[]
}

const Profiles = ({ items }: IProps) => {
  return (
    <>
      {items.length ? (
        <Wrapper>
          {items.slice(0, 2).map((item) => (
            <Tooltip key={item.id} title={item.name} placement="top">
              <ProfileBadge name={item.name} color={item.color} compact />
            </Tooltip>
          ))}
          {items.length > 2 && (
            <Tooltip
              title={items
                .slice(2)
                .map((item) => item.name)
                .join(', ')}
              placement="top"
            >
              <ProfileOverflowBadge>+{items.length - 2}</ProfileOverflowBadge>
            </Tooltip>
          )}
        </Wrapper>
      ) : (
        '--'
      )}
    </>
  )
}

export default Profiles
